import { useState } from 'react';
import { useAuth } from '../auth/AuthContext';
import { api } from '../api/client';

// Combined login / first-run admin setup screen.
export function AuthScreen() {
  const { needsSetup, setUser } = useAuth();
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const user = needsSetup
        ? await api.setup({ email, name, password })
        : await api.login({ email, password });
      setUser(user);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Something went wrong');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-wrap">
      <div className="card auth-card">
        <div className="logo-lg">3D</div>
        <h1>{needsSetup ? 'Create admin account' : 'Sign in'}</h1>
        <p className="muted" style={{ marginTop: 0 }}>
          {needsSetup
            ? 'First run — set up the administrator for The AI Solution.'
            : 'The AI Solution · 3DTSI Estimating'}
        </p>
        {needsSetup && <div className="banner">No users exist yet. The account you create now becomes the Admin.</div>}
        <form onSubmit={submit}>
          {needsSetup && (
            <div className="field">
              <label htmlFor="name">Full name</label>
              <input id="name" value={name} onChange={(e) => setName(e.target.value)} required />
            </div>
          )}
          <div className="field">
            <label htmlFor="email">Email</label>
            <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div className="field">
            <label htmlFor="password">Password</label>
            <input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              minLength={8} required />
          </div>
          {error && <div className="error">{error}</div>}
          <button className="btn btn-primary" type="submit" disabled={busy} style={{ width: '100%', justifyContent: 'center' }}>
            {busy ? 'Please wait…' : needsSetup ? 'Create admin & continue' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
